module.exports = __webpack_public_path__ + "img/bg_empty.ccaaf5ba.svg";